export const APARTMENT_LOCATOR_NOTIFICATION_PHONE_NUMBER = '5127101208';

export const LEAD_STATUS_ASSIGNED = 'assigned';
export const LEAD_STATUS_CLIENT = 'client';
export const LEAD_STATUS_TOURED = 'toured';
export const LEAD_STATUS_APPLIED = 'applied';
export const LEAD_STATUS_LEASE_SIGNED = 'leaseSigned';
export const LEAD_STATUS_ARCHIVED = 'archived';

export const LEAD_ACTIVITY_BOOKMARK = 'bookmark';
export const LEAD_ACTIVITY_CHECK_AVAILABILITY = 'checkAvailability';
export const LEAD_ACTIVITY_ASSIGNED = 'assigned';

export const APT_LEAD_ASSIGNMENT_CONTEXT_SIGNUP = 'SIGNUP';
export const APT_LEAD_ASSIGNMENT_CONTEXT_OPT_IN_HIGH_BUDGET = 'OPT_IN_HIGH_BUDGET';
export const APT_LEAD_ASSIGNMENT_CONTEXT_FORCED_LOW_BUDGET = 'FORCED_LOW_BUDGET';
export const APT_LEAD_ASSIGNMENT_CONTEXT_UPCOMING_MOVE = 'UPCOMING_MOVE';
export const APT_LEAD_ASSIGNMENT_CONTEXT_SUNROOM_TEAM_DIRECT = 'SUNROOM_TEAM_DIRECT';
export const APT_LEAD_ASSIGNMENT_CONTEXT_SUNROOM_TEAM_ROUNDROBIN = 'SUNROOM_TEAM_ROUNDROBIN';
export const APT_LEAD_ASSIGNMENT_CONTEXT_UPDATED_FILTERS = 'UPDATED_FILTERS';
export const APT_LEAD_ASSIGNMENT_CONTEXT_LOCATOR_CREATED = 'LOCATOR_CREATED';
export const APT_LEAD_ASSIGNMENT_CONTEXT_LOCATOR_INVITED = 'LOCATOR_INVITED';
export const APT_LEAD_ASSIGNMENT_CONTEXT_OUT_OF_RANGE_SCRIPT =
  'APT_LEAD_ASSIGNMENT_CONTEXT_OUT_OF_RANGE_SCRIPT'; // eslint-disable-line max-len

export const APT_LEAD_ASSIGNMENT_DISPLAY_CONTEXT_SIGNUP = 'Signup';
export const APT_LEAD_ASSIGNMENT_DISPLAY_CONTEXT_UPCOMING_MOVE = 'Upcoming move';
export const APT_LEAD_ASSIGNMENT_DISPLAY_CONTEXT_SUNROOM_TEAM = 'Sunroom team assigned to you';
export const APT_LEAD_ASSIGNMENT_DISPLAY_CONTEXT_UPDATED_FILTERS = 'Changed filters';
export const APT_LEAD_ASSIGNMENT_DISPLAY_CONTEXT_LOCATOR_CREATED = 'Created by you';
export const APT_LEAD_ASSIGNMENT_DISPLAY_CONTEXT_LOCATOR_INVITED = 'Invited by you';
export const APT_LEAD_ASSIGNMENT_DISPLAY_CONTEXT_ADMIN_SCRIPT = 'Admin Script';

export const LEAD_STATUS_LIST = [
  LEAD_STATUS_ASSIGNED,
  LEAD_STATUS_CLIENT,
  LEAD_STATUS_TOURED,
  LEAD_STATUS_APPLIED,
  LEAD_STATUS_LEASE_SIGNED,
  LEAD_STATUS_ARCHIVED,
];

export const LEAD_STEP_STATUS_LIST = [
  LEAD_STATUS_ASSIGNED,
  LEAD_STATUS_CLIENT,
  LEAD_STATUS_TOURED,
  LEAD_STATUS_APPLIED,
  LEAD_STATUS_LEASE_SIGNED,
  LEAD_STATUS_ARCHIVED,
];

export function getLeadStatusLabel({ leadStatus, isSingular }) {
  switch (leadStatus) {
    case LEAD_STATUS_ASSIGNED:
      return isSingular ? 'leads' : 'Leads';
    case LEAD_STATUS_CLIENT:
      return isSingular ? 'client' : 'Clients';
    case LEAD_STATUS_TOURED:
      return isSingular ? 'toured' : 'Toured';
    case LEAD_STATUS_APPLIED:
      return isSingular ? 'applied' : 'Applied';
    case LEAD_STATUS_LEASE_SIGNED:
      return isSingular ? 'signed' : 'Signed';
    case LEAD_STATUS_ARCHIVED:
      return isSingular ? 'archive' : 'Archived';
  }
}

export const APARTMENT_LOCATOR_TOGGLE_LEADS_SOURCE_LOCATOR_PROFILE =
  'toggleLeadsSource:LocatorProfile';
export const APARTMENT_LOCATOR_TOGGLE_LEADS_SOURCE_CRON = 'toggleLeadsSource:Cron';

export const APARTMENT_LOCATOR_ARCHIVE_LEAD_REASON_BAD_PHONE_CONTACT_INFO = 'badPhoneContactInfo';
export const APARTMENT_LOCATOR_ARCHIVE_LEAD_REASON_FOUND_A_PLACE_ON_THEIR_OWN =
  'foundAPlaceOnTheirOwn';
export const APARTMENT_LOCATOR_ARCHIVE_LEAD_REASON_NOT_INTERESTED_IN_SERVICES =
  'notInterestedInServices';
export const APARTMENT_LOCATOR_ARCHIVE_LEAD_REASON_LOOKING_FOR_HOMES = 'lookingForHomes';
export const APARTMENT_LOCATOR_ARCHIVE_LEAD_REASON_NO_RESPONSE = 'noResponse';
export const APARTMENT_LOCATOR_ARCHIVE_LEAD_REASON_LOW_BUDGET = 'lowBudget';
export const APARTMENT_LOCATOR_ARCHIVE_LEAD_REASON_LOCATION_TOO_FAR = 'locationTooFar';
export const APARTMENT_LOCATOR_ARCHIVE_LEAD_REASON_RENEWING_CURRENT_LEASE = 'renewingCurrentLease';
export const APARTMENT_LOCATOR_ARCHIVE_LEAD_REASON_OTHER = 'other';

export const APARTMENT_LOCATOR_ARCHIVE_LEAD_REASON_OPTION_ITEMS = [
  {
    label: 'Bad phone / contact info',
    value: APARTMENT_LOCATOR_ARCHIVE_LEAD_REASON_BAD_PHONE_CONTACT_INFO,
  },
  {
    label: 'Found a place on their own',
    value: APARTMENT_LOCATOR_ARCHIVE_LEAD_REASON_FOUND_A_PLACE_ON_THEIR_OWN,
  },
  {
    label: 'Not interested in services',
    value: APARTMENT_LOCATOR_ARCHIVE_LEAD_REASON_NOT_INTERESTED_IN_SERVICES,
  },
  {
    label: 'Looking for homes',
    value: APARTMENT_LOCATOR_ARCHIVE_LEAD_REASON_LOOKING_FOR_HOMES,
  },
  {
    label: 'Lead unresponsive',
    value: APARTMENT_LOCATOR_ARCHIVE_LEAD_REASON_NO_RESPONSE,
  },
  {
    label: 'Low budget',
    value: APARTMENT_LOCATOR_ARCHIVE_LEAD_REASON_LOW_BUDGET,
  },
  {
    label: 'Location too far',
    value: APARTMENT_LOCATOR_ARCHIVE_LEAD_REASON_LOCATION_TOO_FAR,
  },
  {
    label: 'Renewing current lease',
    value: APARTMENT_LOCATOR_ARCHIVE_LEAD_REASON_RENEWING_CURRENT_LEASE,
  },
];

export const LEAD_ARCHIVE_ALL_REASONS_OPTION_ITEMS = [
  {
    label: 'Accepted another listing',
    value: 'acceptedAnotherListing',
    question: 'What is the address of the other listing?',
  },
  {
    label: 'Accidental Lead',
    value: 'accidentalLead',
  },
  {
    label: 'Bad Contact Info',
    value: 'badContactInfo',
  },
  {
    label: 'Corporate Lease',
    value: 'corporateLease',
  },
  {
    label: 'Credit Score Low',
    value: 'creditScoreLow',
  },
  {
    label: 'Doesn’t like the area',
    value: 'doesntLikeTheArea',
    question: 'What about the area do they not like?',
  },
  {
    label: 'Doesn’t qualify',
    value: 'doesntQualify',
  },
  {
    label: 'Dog Breed',
    value: 'dogBreed',
    question: 'What is their dog breed?',
  },
  {
    label: 'Home In Poor Condition',
    value: 'homeInPoorCondition',
  },
  {
    label: 'Home Too Small',
    value: 'homeTooSmall',
  },
  {
    label: 'Home Too Big',
    value: 'homeTooBig',
  },
  {
    label: 'Kitchen Old',
    value: 'kitchenOld',
  },
  {
    label: 'Missing appliance(s)',
    value: 'missingAppliances',
    question: 'Which appliance(s) is missing?',
  },
  {
    label: 'Move in date doesn’t match',
    value: 'moveInDateDoesntMatch',
    question: 'When is the earliest they could move-in?',
  },
  {
    label: 'Needs Section 8 / Voucher',
    value: 'needsSection8',
  },
  {
    label: 'No longer in town',
    value: 'noLongerInTown',
  },
  {
    label: 'Lead unresponsive',
    value: 'noResponse',
  },
  {
    label: 'Not pet friendly',
    value: 'notPetFriendly',
  },
  {
    label: 'Partner accepted another app',
    value: 'partnerAcceptedAnotherApp',
  },
  {
    label: 'Price too high',
    value: 'priceTooHigh',
    question: 'What price could they afford?',
  },
  {
    label: 'Recent Bankruptcy',
    value: 'recentBankruptcy',
  },
  {
    label: 'Recent Crime',
    value: 'recentCrime',
  },
  {
    label: 'Recent Eviction',
    value: 'recentEviction',
  },
  {
    label: 'Short Term Lease',
    value: 'shortTermLease',
  },
  {
    label: 'Stayed at Current Rental',
    value: 'stayedAtCurrentRental',
  },
  {
    label: 'Submitted another app',
    value: 'submittedAnotherApp',
  },
  {
    label: 'Too Many Pets',
    value: 'tooManyPets',
    question: 'How many do they have?',
  },
  {
    label: 'Wants to Purchase Home',
    value: 'wantsToPurchaseHome',
  },
  {
    label: 'Duplicate',
    value: 'duplicate',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const LEAD_ARCHIVE_ALL_REASONS_OPTION_ITEMS_TO_VALUE = LEAD_ARCHIVE_ALL_REASONS_OPTION_ITEMS.reduce(
  (memo, option) => {
    return {
      ...memo,
      [option.value]: option,
    };
  },
  {},
);

export const LEAD_ARCHIVE_REASON_VALUES = [
  'acceptedAnotherListing',
  'accidentalLead',
  'badContactInfo',
  'corporateLease',
  'creditScoreLow',
  'doesntLikeTheArea',
  'dogBreed',
  'homeInPoorCondition',
  'homeTooSmall',
  'homeTooBig',
  'missingAppliances',
  'moveInDateDoesntMatch',
  'needsSection8',
  'noLongerInTown',
  'noResponse',
  'notPetFriendly',
  'partnerAcceptedAnotherApp',
  'priceTooHigh',
  'recentBankruptcy',
  'recentCrime',
  'recentEviction',
  'shortTermLease',
  'stayedAtCurrentRental',
  'submittedAnotherApp',
  'wantsToPurchaseHome',
  'other',
];

export const LEAD_ARCHIVE_ACTIVE_REASONS_OPTION_ITEMS = LEAD_ARCHIVE_ALL_REASONS_OPTION_ITEMS.filter(
  (option) => {
    return option.value !== 'doesntQualify';
  },
);

export const LEAD_ANALYTICS_STARTED_DATE = '2023-10-12T14:23:03.664Z';

export const LEAD_STAGES = [
  {
    id: 'LeaseSigned',
    label: 'Lease Signed',
    description: '',
    score: 40,
  },
  {
    id: 'LeasePending',
    label: 'Lease Pending',
    description: '',
    score: 38,
  },
  {
    id: 'HouseholdAllAppsCompleted',
    label: 'All apps in household completed',
    description: '',
    score: 35,
  },
  {
    id: 'HouseholdSomeAppsCompleted',
    label: 'Some apps in household completed',
    description: '',
    score: 30,
  },
  {
    id: 'HouseholdOneAppCompleted',
    label: 'One app in household completed',
    description: '',
    score: 25,
  },
  {
    id: 'WantsToApply',
    label: 'Wants To Apply',
    description: '',
    score: 20,
  },
  {
    id: 'TourNoFeedack',
    label: 'Toured but not feedback',
    description: '',
    score: 13,
  },
  {
    id: 'TourScheduled',
    label: 'Tour Scheduled',
    description: '',
    score: 12,
  },
  {
    id: 'ContactedRecently',
    label: 'Contacted Recently',
    description: '',
    score: 10,
  },
  {
    id: 'ContactedWeeksAgo',
    label: 'Last contact was over 1 week ago',
    description: '',
    score: 5,
  },
  {
    id: 'ContactedLongAgo',
    label: 'Last contact was over 14d ago',
    description: '',
    score: -3,
  },
  {
    id: 'NotInterested',
    label: 'Not Interested',
    description: '',
    score: -5,
  },
  {
    id: 'Archived',
    label: 'Archived',
    description: '',
    score: -10,
  },
];

export const getLeadStageSettings = (stage) => LEAD_STAGES.find(({ id }) => stage === id) || null;
